import { ApiService } from "../..";

export const getUserSampleDetail = (userId: string) => {
    return ApiService.baseAction("user/sample_list/" + userId, {}, "get");
    
};